import { PopoverComponent } from './popover/popover';
import { PopupComponent } from './popup/popup';
import { PopupContainerComponent } from './popup_container/popup_container';

angular
  .module('ui-ng-popup')
  .component('popupContainer', new PopupContainerComponent())
  .component('uiNgPopup', new PopupComponent())
  .component('popOver', new PopoverComponent());



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popup/src/components/components_module.ts